<template>
  <v-progress-linear v-if="isLoading" indeterminate />
  <v-card v-else>
    <v-card-text>
      <v-alert color="warning" dark v-if="!hasCourse">
        To access to the course you must surbscribe, please suscribe to a school
        package form
        <v-btn x-small color="white" light to="/search?find=package"
          >here</v-btn
        >
      </v-alert>
      <v-dialog
        v-if="!hideOnMobile"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-card-text
            >The course is under development. Please click on the button bellow
            to see a demo. You have to contact your school to manage
            Credentials</v-card-text
          >
          <v-btn color="primary" dark v-bind="attrs" v-on="on" block>
            View Course
          </v-btn>
        </template>-->
        <v-toolbar dark color="primary">
          <v-toolbar-title>Course</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- https://thedriverx.com/c_s/index.html -->
        <iframe
          src="http://learn.thedriverx.com/login/index.php"
          style="
            position: fixed;
            top: 56px;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: calc(100vh - 56px);
            border: none;
            margin: 0;
            padding: 0;
            overflow: hidden;
            z-index: 999999;
          "
        />
      </v-dialog>

      <template v-if="hasCourse">
        <v-card-text
          >Please click the link and scroll down to create new
          account</v-card-text
        >
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          block
          @click="showInApp"
        >
          View Course
        </v-btn>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      isLoading: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      hasCourse: false,
      hideOnMobile: true,
      showOnMobileButton: true,
      on: '',
      attrs: ''
    }
  },
  computed: mapGetters(['user', 'schoolPackageJoinedId']),
  methods: {
    ...mapActions(['toggleDialog', 'getSchoolPackageJoinedById']),
    showInApp () {
      if (typeof cordova !== 'undefined') {
        var url = 'http://learn.thedriverx.com/login/index.php'
        var target = '_system'
        var options =
            'location=no,toolbar=yes,clearsessioncache=yes,clearcache=yes,hideurlbar=yes,closebuttoncaption=Close,hidenavigationbuttons=yes'
        var inAppBrowserRef = null
        inAppBrowserRef = window.cordova.InAppBrowser.open(
          url,
          target,
          options
        )
        // inAppBrowserRef.addEventListener('loadstart', loadStartCallBack);
        // inAppBrowserRef.addEventListener('loadstop', loadStopCallBack);
        inAppBrowserRef.addEventListener('exit', this.loadExitCallBack)
        inAppBrowserRef.addEventListener('message', this.messageCallBack)
      } else {
        window.open('http://learn.thedriverx.com/login/index.php', '_blank')
      }
    },
    loadStartCallBack () {},
    messageCallBack () {}
  },
  async created () {
    this.isLoading = true
    /** Get the school package information this student joined */
    await this.getSchoolPackageJoinedById({
      studentId: this.user.id
    })
    console.log(this.schoolPackageJoinedId)
    if (this.schoolPackageJoinedId) {
      this.isLoading = false
      this.hasCourse = true
      /** For mobile and web, we have different logics */
      if (typeof cordova !== 'undefined') {
        /** Mobile */
        this.showInApp()
      } else {
        this.hideOnMobile = false
        this.showOnMobileButton = false
      }
    } else {
      this.isLoading = false
    }

    document.addEventListener(
      typeof cordova !== 'undefined' ? 'deviceready' : 'DOMContentLoaded',
      () => {
        console.log('deviceready')
      }
    )
  }
}
</script>
